import React from 'react';
import styled from 'styled-components';

export const HeaderCell = React.memo(styled.div<{ align?: string; interactive?: boolean }>`
  padding: 4px 8px;
  font-weight: 300;
  display: flex;
  align-items: center;
  ${({ align }) =>
    align &&
    `
      text-align: ${align}; 
      ${align === 'right' ? 'justify-content: flex-end' : ''}`};
  ${({ interactive }) => interactive && `cursor: pointer`};
`);

export const HeaderIconCell = React.memo(styled.div`
  padding: 4px 8px;
  align-items: center;
  justify-content: center;
`);
